import sample_1 from './100_39330.jpg';
import sample_2 from './100_39408.jpg';
import sample_3 from './100_39413.jpg';

export const dynamicOutdoorImpressions = {
    sample_1,
    sample_2,
    sample_3,
};
